<ng-container
  *ngIf="
    isCustomTranslationsEnabled !== null &&
    isTaxRelatedCustomTranslationsEnabled !== null &&
    showDynamicDateFormat !== null &&
    showSplitDelivery !== null &&
    showOrderTypes !== null &&
    order
  "
>
  <div class="container-group">
    <div class="summary-title">
      <h2>{{ 'myAccount.orderDetails.orderSummary.title' | cxTranslate }}</h2>
    </div>
    <div class="summary-details">
      <div class="group-info" *ngIf="!features?.hideOrderStatus">
        <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderStatus' | cxTranslate }}</div>
        <div class="value status-icon">
          <mat-icon [svgIcon]="getStatusIcon(order?.statusCode)"></mat-icon>
          {{ order?.statusDisplay }}
        </div>
      </div>
      <div class="group-info">
        <div class="label" *ngIf="isCustomTranslationsEnabled !== null">
          {{
            'myAccount.orderDetails.orderSummary.orderNumber'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </div>
        <div class="value">{{ order?.erpOrderNumber }}</div>
      </div>
      <div class="group-info">
        <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderPoNumber' | cxTranslate }}</div>
        <div class="value">{{ order?.purchaseOrderNumber }}</div>
      </div>
      <div class="group-info">
        <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderDate' | cxTranslate }}</div>
        <div class="value date" *ngIf="showDynamicDateFormat !== null">
          {{ order?.createdDateString | date : (showDynamicDateFormat ? (dateFormat$ | async) : 'dd/MM/yy; h:mma') }}
        </div>
      </div>
      <div class="group-info" *ngIf="!this.features.hideOrderBySplitDeliveryField">
        <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderBy' | cxTranslate }}</div>
        <app-tooltip-text
          class="value has-tooltip order-details-tooltip"
          [tooltipContent]="order?.placedBy"
          [content]="order?.placedBy"
          placement="bottom"
        ></app-tooltip-text>
      </div>
      <div *ngIf="showOrderTypes" class="group-info">
        <div class="label">{{ 'orders.orderType' | cxTranslate }}</div>
        <div class="value">{{ order?.orderType }}</div>
      </div>
      <div class="group-info" *ngIf="!this.features.hideOrderBySplitDeliveryField && showSplitDelivery">
        <div class="label">{{ 'myAccount.orderDetails.orderSummary.splitDelivery' | cxTranslate }}</div>
        <div class="value">
          {{
            !order?.deliverFullOrder
              ? ('myAccount.orderDetails.orderSummary.splitDeliveryTrue' | cxTranslate)
              : ('myAccount.orderDetails.orderSummary.splitDeliveryFalse' | cxTranslate)
          }}
        </div>
      </div>
      <div class="group-info" *ngIf="features.showHoldStatus">
        <div class="label">{{ 'orders.holdStatus' | cxTranslate }}</div>
        <app-tooltip-text
          class="value has-tooltip order-details-tooltip"
          [tooltipContent]="order?.holdCode"
          [content]="order?.holdCode"
          placement="bottom"
        ></app-tooltip-text>
      </div>
    </div>
  </div>
  <hr class="line-summary" />
  <div class="container-group summary-total">
    <div class="summary-details">
      <div class="group-info">
        <div class="label" *ngIf="isTaxRelatedCustomTranslationsEnabled !== null">
          {{
            'myAccount.orderDetails.orderTotalSummary.subtotal'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isTaxRelatedCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </div>
        <div class="value" *ngIf="!showSrp">{{ order?.subTotal?.formattedValue }}</div>
      </div>
      <div class="group-info" *ngIf="!OrderDetailsHideDiscountEnabled">
        <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.discount' | cxTranslate }}</div>
        <div class="value" *ngIf="!showSrp">{{ order?.orderDiscounts?.formattedValue }}</div>
      </div>
      <div
        class="group-info"
        *ngIf="!(showActiveSnahCountry$ | async) && showDeliveryFee && order?.deliveryCost; else snahCountry"
      >
        <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.deliveryFee' | cxTranslate }}</div>
        <div class="value" *ngIf="!showSrp">
          {{
            order?.deliveryCost?.value > 0
              ? order?.deliveryCost?.formattedValue
              : showFreeDelivery
              ? ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
              : order?.deliveryCost?.formattedValue
          }}
        </div>
      </div>
      <div #snahCountry class="group-info" *ngIf="showActiveSnahCountry$ | async">
        <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.deliveryFee' | cxTranslate }}</div>
        <div class="value" *ngIf="!showSrp && order?.freeShipping; else noFreeDelivery">
          {{ 'myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate }}
        </div>
        <div class="value" *ngIf="!showSrp && !order?.freeShipping" #noFreeDelivery>
          {{
            hasNoFreeDelivery(order) === 'feeInProgress'
              ? ('myAccount.orderDetails.orderTotalSummary.calculateFee' | cxTranslate)
              : order?.deliveryCost?.formattedValue
          }}
        </div>
      </div>
      <div class="group-info" *ngIf="!features.disabledTax">
        <div class="label" *ngIf="isTaxRelatedCustomTranslationsEnabled !== null">
          {{
            'myAccount.orderDetails.orderTotalSummary.tax'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isTaxRelatedCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </div>
        <div class="value" *ngIf="!showSrp">{{ order?.totalTax?.formattedValue }}</div>
      </div>
      <div [ngClass]="['group-info', 'total', activeCountry$ | async]">
        <div class="label" *ngIf="isTaxRelatedCustomTranslationsEnabled !== null">
          {{
            'myAccount.orderDetails.orderTotalSummary.total'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isTaxRelatedCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </div>
        <div class="value" *ngIf="!showSrp">{{ order?.totalPrice?.formattedValue }}</div>
      </div>
      <div class="group-info">
        <div *ngIf="features.shippingTaxTextEnabled" class="tax-delivery-fee">
          {{ 'myAccount.orderDetails.orderTotalSummary.taxDeliveryFee' | cxTranslate }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
